import { atom } from "jotai";

import { currentPreferencesAtom } from "./preferencesAtom";

/**
 * Writable boolean atom for sidebar collapsed state.
 * Reads from current persona preferences; writes update preferences storage.
 */
export const sidebarCollapsedAtom = atom(
  (get) => get(currentPreferencesAtom).navCollapsed,
  (_get, set, collapsed: boolean) => {
    set(currentPreferencesAtom, { navCollapsed: collapsed });
  },
);
